module.exports = __webpack_public_path__ + "static/media/blue-star-outline.7a573af0.svg";